import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ce0a077"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-responsive mt-5" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, " #ID "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, " Freelancer "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, " Hours worked "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-180px" }, " Salary Distribution "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px text-end" }, "Actions")
  ])
], -1))
const _hoisted_4 = { class: "text-dark fw-bolder d-block fs-6" }
const _hoisted_5 = { class: "text-dark fw-bolder d-block fs-6" }
const _hoisted_6 = { class: "mw-225px" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "d-flex justify-content-end flex-row align-items-start" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = ["onClick", "disabled"]
const _hoisted_12 = {
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SalaryExportsHistoryModal = _resolveComponent("SalaryExportsHistoryModal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SalarySplit = _resolveComponent("SalarySplit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_SalaryExportsHistoryModal, {
      key: _ctx.modalKey,
      userID: _ctx.userID
    }, null, 8, ["userID"])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (entry) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: entry.id
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(entry.id), 1)
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  class: "text-dark fw-bolder d-block fs-6",
                  to: '/users/' + entry.id + '/personal'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(entry.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.calculateApprovedHours(entry.approved_hours)), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_SalarySplit, {
                    salaryData: entry.salary_distribution
                  }, null, 8, ["salaryData"])
                ])
              ]),
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "btn btn-sm btn-info mx-2",
                    onClick: _withModifiers(($event: any) => (_ctx.shiftsButtonClick(entry.id)), ["prevent"]),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#shifts_modal"
                  }, "View Shifts", 8, _hoisted_9),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.downloadButtonClick(entry.id)),
                      disabled: _ctx.isAwaitingResponse.ids.includes(entry.id),
                      class: "btn btn-sm btn-warning"
                    }, [
                      _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [
                        [_vShow, _ctx.isAwaitingResponse.ids.includes(entry.id)]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.isAwaitingResponse.ids.includes(entry.id)
                      ? "Download Salary Re..."
                      : "Download Salary Report"), 1)
                    ], 8, _hoisted_11),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.handlePreviousReports(entry.id)),
                      class: "fs-6 fw-bold text-gray cursor-pointer"
                    }, "See previous exports", 8, _hoisted_13)
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-icon btn-success mx-2",
                    onClick: ($event: any) => (_ctx.openPayModal(entry))
                  }, "Pay", 8, _hoisted_14)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}